import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import { Icon } from "../../ui";
import "./analytics.css";

const LivePage = lazy(() => import("./live").then((m) => ({ default: m.LivePage })));
const AnalyticsPage = lazy(() => import("./overview").then((m) => ({ default: m.AnalyticsPage })));
const AnalyticsSettings = lazy(() => import("./settings").then((m) => ({ default: m.AnalyticsSettings })));
const ShopAnalyticsPage = lazy(() => import("./shop").then((m) => ({ default: m.ShopAnalyticsPage })));
const TrafficPage = lazy(() => import("./traffic").then((m) => ({ default: m.TrafficPage })));

/**
 * Analytics: the members' site's visits, counted by the site itself, beside the shop's sales and the club's
 * accounts and registrations. The overview at /analytics, with Traffic, Shop and Live View.
 */

export const routes: SolutionRoute[] = [
  { solution: "analytics", path: "analytics", element: <AnalyticsPage /> },
  { solution: "analytics", path: "analytics/traffic", element: <TrafficPage /> },
  { solution: "analytics", path: "analytics/shop", element: <ShopAnalyticsPage /> },
  { solution: "analytics", path: "analytics/live", element: <LivePage /> },
];

export const settings: SolutionSettings[] = [{ solution: "analytics", key: "analytics", label: "Analytics", icon: Icon.chart, need: "analytics.view", Component: AnalyticsSettings }];
